import DocumentCard from "../../../developer/component/detail/DocumentCard";
import UploadDocument from "../../../developer/component/uploadDoc";
import { Button, Col, Row } from "reactstrap";
import { Select } from "antd";
const DocumentMerchand = ({
  merchant,
  merchantDocs,
  loadingDocs,
  documents,
  setDocuments,
  docType,
  setDocType,
  handleSubmitDocuments,
  isSubmitting
}) => {

  const currentuser = JSON.parse(sessionStorage.getItem("authAdmin"));

  const handleDocChange = (key, file) => {
    setDocuments((prev) => ({
      ...prev,
      [key]: file,
    }));
  };

  const hasAllDocs =
    merchantDocs?.recto &&
    merchantDocs?.verso &&
    merchantDocs?.rib &&
    merchantDocs?.domicile;

  const docList = [
    {
      key: "recto",
      title: "Recto",
      condition: docType && !merchantDocs?.recto,
    },
    {
      key: "verso",
      title: "Verso",
      condition: docType === "CNI" && !merchantDocs?.verso,
    },
    {
      key: "rib",
      title: "RIB ou attestation bancaire",
      condition: !merchantDocs?.rib,
    },
    {
      key: "domicile",
      title: "Justificatif de domicile",
      condition: !merchantDocs?.domicile,
    },
  ];
  const docPreviewList = [
    merchantDocs?.recto && { key: "recto", title: "Recto", file: merchantDocs.recto },
    merchantDocs?.verso && { key: "verso", title: "Verso", file: merchantDocs.verso },
    merchantDocs?.rib && { key: "rib", title: "RIB", file: merchantDocs.rib },
    merchantDocs?.domicile && { key: "domicile", title: "Justificatif de domicile", file: merchantDocs.domicile },
  ].filter(Boolean);

  return (
    <div style={{ padding: "15px" }}>
      <Row className="justify-content-center">
        <Col span={24}>

          {/* TYPE DOC */}
          {!loadingDocs && !hasAllDocs && (
            <div style={{ maxWidth: "500px", margin: "0 auto 25px auto" }}>
              <label>Type de document</label>
              <Select
                placeholder="Sélectionner le type de document"
                value={docType || undefined}
                onChange={(value) => setDocType(value)}
                style={{ width: "100%" }}
                options={[
                  { value: "CNI", label: "Carte Nationale d'identité" },
                  { value: "PASSPORT", label: "Passeport" },
                ]}
              />
            </div>
          )}
          {docPreviewList.length > 0 && (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                gap: "16px",
                marginBottom: "25px",
              }}
            >
              {docPreviewList.map((doc) => (
                <div key={doc.key} style={{ width: "100%" }}>
                  <DocumentCard
                    title={doc.title}
                    file={doc.file}
                    token={currentuser?.token}
                  />
                </div>
              ))}
            </div>
          )}

          {/* UPLOAD ZONE */}
          {!hasAllDocs && (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                gap: "16px",
                marginBottom: "20px",
              }}
            >
              {docList.map((doc) =>
                doc.condition ? (
                  <UploadDocument
                    key={doc.key}
                    label={doc.title}
                    value={documents?.[doc.key]}
                    onChange={(file) => handleDocChange(doc.key, file)}
                    colSize={12}
                  />
                ) : null
              )}
            </div>
          )}

          {/* BUTTON */}
          {!hasAllDocs && (
            <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
              <Button
                className="buttonNewColla"
                disabled={isSubmitting}
                onClick={handleSubmitDocuments}
              >
                Soumettre les documents
              </Button>
            </div>
          )}

        </Col>
      </Row>
    </div>
  );
};

export default DocumentMerchand;